import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'
import { map, of, tap } from 'rxjs'
import { AppService } from '../services/app.service'

export const countriesResolver: ResolveFn<boolean> = (route, state) => {
  const _appService = inject(AppService)
  if (_appService.areCountriesLoaded()) return of(true)

  return _appService.getAllCountries().pipe(
    tap((response) => {
      _appService.countries = response.data.countries
    }),
    map(() => true)
  )
}
